import React from 'react';
import { ProgressBar, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faBuilding,
  faTools,
  faHistory,
  faCalendarAlt,
  faNetworkWired,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';

const WizardProgress = ({ 
  currentStep, 
  wizardLabels, 
  isCurrentStep, 
  isStepCompleted, 
  goToStep,
  isSubmitting 
}) => {
  const totalSteps = wizardLabels.length;
  const currentProgress = isSubmitting ? currentStep + 0.5 : currentStep;

  return (
    <div className="mb-4">
      <div className="step-indicator d-flex justify-content-between mb-2">
        {wizardLabels.map((label, index) => (
          <div
            key={index}
            className="step-item text-center"
            style={{ cursor: index <= currentStep ? 'pointer' : 'not-allowed', flex: 1 }}
            onClick={() => goToStep(index)}
          >
            <div
              className={`rounded-circle d-inline-flex align-items-center justify-content-center ${
                isCurrentStep(index)
                  ? 'bg-primary-soft text-primary border border-primary'
                  : isStepCompleted(index)
                    ? 'bg-primary text-white'
                    : 'bg-dark-accent text-muted'
              }`}
              style={{
                width: '36px',
                height: '36px',
                border: isCurrentStep(index)
                  ? '2px solid #4D7AFF'
                  : isStepCompleted(index)
                    ? '1px solid #4D7AFF'
                    : '1px solid rgba(255, 255, 255, 0.08)',
                transition: 'all 0.2s ease',
                background: isCurrentStep(index)
                  ? 'rgba(77, 122, 255, 0.1)'
                  : isStepCompleted(index)
                    ? '#4D7AFF'
                    : 'rgba(255, 255, 255, 0.05)',
                color: isCurrentStep(index)
                  ? '#4D7AFF'
                  : isStepCompleted(index)
                    ? '#ffffff'
                    : '#adb5bd'
              }}
            >
              {isStepCompleted(index) && !isCurrentStep(index) ? (
                <FontAwesomeIcon icon={faCheck} size="sm" />
              ) : isSubmitting && isCurrentStep(index) ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <FontAwesomeIcon
                  icon={
                    [faBuilding, faTools, faHistory, faCalendarAlt, faNetworkWired, faExclamationTriangle, faCheck][index] ||
                    faCheck
                  }
                  size="sm"
                />
              )}
            </div>
            <div className="mt-1">
              <small
                style={{
                  color: isCurrentStep(index) || isStepCompleted(index) ? '#4D7AFF' : '#adb5bd',
                  fontWeight: isCurrentStep(index) ? '600' : '400',
                  fontSize: '0.75rem'
                }}
              >
                {label}
              </small>
            </div>
          </div>
        ))}
      </div>
      <ProgressBar
        now={((currentProgress) / (totalSteps - 1)) * 100}
        variant="primary"
        style={{
          height: '6px',
          borderRadius: '3px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)'
        }}
      />
    </div>
  );
};

export default WizardProgress;